export default "__VITE_ASSET__BGnZiSUp__"